import React from "react";
import { Card, Flex, Icon } from "@telia/teddy";
import _isEmpty from "lodash/isEmpty";
import "./PackageButton.less";

type PackageButtonProps = {
    duration: string;
    onClick: () => void;
    price: number;
    size: string;
};

const PackageButton: React.FC<PackageButtonProps> = ({ price, duration, size, onClick }) => {
    return (
        <Card
            className="prepaid-refill-package__packageType"
            layout="navigation-horizontal-large"
            bordered
            variant="white"
        >
            <Card.Heading className="prepaid-refill-package__packageType--heading">
                <Flex className="prepaid-refill-package__packageContainer">
                    {!_isEmpty(size) ? <div className="prepaid-refill-package__heading-element">{size}</div> : null}
                    <div className="prepaid-refill-package__heading-element">{`${price},-`}</div>
                </Flex>
            </Card.Heading>
            <Card.Button variant="secondary" aria-label="Velg" iconOnly onClick={onClick}>
                <Icon name="arrow-right" aria-hidden="true" focusable="false" />
            </Card.Button>
            {duration && <Card.Content>{duration}</Card.Content>}
        </Card>
    );
};

export default PackageButton;
